export const SHUTTERBUG_PROMO_FEATURES = [
  {
    icon: '/face-only.svg',
    title: 'Photo delivery with AI-powered matching.',
  },
  {
    icon: '/new-event-illustration.svg',
    title: 'Seamless sharing between iOS, Android, & Web.',
  },
  {
    icon: '/cloud-value-illustration.svg',
    title: 'Up to 200 GB of cloud storage.',
  },
  {
    icon: '/prints-saves-illustration.svg',
    title: 'Save up to 15% off all prints.',
  },
];
